module.exports = __webpack_public_path__ + "static/wta-7d3aaf3735cb358ece5202c244d56c97.png";